
<template>
    <div :class="['tc-tbitem', selected ? 'selected-item' : '', { 'tc-tool-menu-open': show_exp_list }]"
        @click="emit_selected('click')"
        @mousedown="mousedown"
        @touchstart="mousedown"
        @touchend="emit_selected('touch')"
        :style="item_style" role="button" tabindex="0"
        :title="data.group || data.name || 'Drawing tool'"
        :aria-label="data.group || data.name || 'Drawing tool'"
        :aria-expanded="has_multiple_items ? show_exp_list : undefined"
        @keydown.enter.prevent="keyboardSelect"
        @keydown.space.prevent="keyboardSelect"
        @keydown.esc.stop="close_list">
        <div class="tc-tbicon"
            :style="icon_style">
        </div>
        <div class="tc-tbitem-exp" v-if="data.group && has_multiple_items"
            :style="exp_style"
            @click="exp_click"
            @mousedown="expmousedown"
            @mouseover="expmouseover"
            @mouseleave="expmouseleave"
            :title="'Click to expand ' + (data.group || 'tools')">
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m4.5 3 3 3-3 3"/></svg>
        </div>
        <Teleport to="body"><item-list :anchor="flyoutAnchor" :config="config" :items="data.items"
            v-if="show_exp_list && has_multiple_items" :colors="colors" :dc="dc"
            @close-list="close_list"
            @item-selected="emit_selected_sub"/></Teleport>
    </div>
</template>

<script>

import ItemList from './ItemList.vue'
import Utils from '../stuff/utils.js'

export default {
    name: 'ToolbarItem',
    props: [
        'data', 'selected', 'colors', 'tv_id', 'config', 'dc', 'subs'
    ],
    components: { ItemList },
    mounted() {
        if (this.data.group) {
            let type = this.subs[this.data.group]
            let item = this.data.items.find(x => x.type === type)
            if (item) this.sub_item = item
        }
    },
    beforeDestroy() { clearTimeout(this.click_id) },
    methods: {
        keyboardSelect() {
            if (this.has_multiple_items) this.show_exp_list = !this.show_exp_list
            else this.$emit('item-selected', this.sub_item || this.data.items?.[0] || this.data)
        },
        mousedown(e) {
            this.click_start = Utils.now()
            this.click_id = setTimeout(() => {
                this.show_exp_list = true
            }, this.config.TB_ICON_HOLD)
        },
        expmouseover() {
            this.exp_hover = true
        },
        expmouseleave() {
            this.exp_hover = false
        },
        expmousedown(e) {
            if (this.show_exp_list) e.stopPropagation()
        },
        emit_selected(src) {
            if (Utils.now() - this.click_start >
                this.config.TB_ICON_HOLD) return
            clearTimeout(this.click_id)
            if (!this.data.group) {
                this.$emit('item-selected', this.data)
            } else {
                let item = this.sub_item || this.data.items[0]
                this.$emit('item-selected', item)
            }
        },
        emit_selected_sub(item) {
            this.show_exp_list = false
            this.$emit('item-selected', item)
            this.sub_item = item
        },
        exp_click(e) {
            if (!this.data.group) return
            e.stopPropagation(); e.preventDefault()
            this.show_exp_list = !this.show_exp_list
        },
        close_list() {
            this.show_exp_list = false
        }
    },
    computed: {
        flyoutAnchor() { return this.$el },
        item_style() {
            if (this.$props.data.type === 'System:Splitter') {
                return this.splitter
            }
            let conf = this.$props.config
            let im = conf.TB_ITEM_M
            let m = (conf.TOOLBAR - conf.TB_ICON) * 0.5 - im
            let s = conf.TB_ICON + im * 2
            let b = this.exp_hover ? 0 : 3
            return {
                'width': `${s}px`,
                'height': `${s}px`,
                'margin': `8px ${m}px 0px ${m}px`,
                'border-radius': `3px ${b}px ${b}px 3px`
            }
        },
        icon_style() {
            if (this.$props.data.type === 'System:Splitter') {
                return {}
            }
            let conf = this.$props.config
            let sz = conf.TB_ICON
            let im = conf.TB_ITEM_M
            let ic = this.sub_item ?
                this.sub_item.icon : this.$props.data.icon

            return {
                'background-image': `url(${ic})`,
                'width': `${sz}px`,
                'height': `${sz}px`,
                'margin': '0',
                'left': '50%',
                'top': '50%',
                'transform': 'translate(-50%, -50%)'
            }
        },
        exp_style() {
            return {
                width: '14px',
                height: '28px',
                top: '2px',
                right: '-4px',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: '1',
                transform: this.show_exp_list ? 'rotate(180deg)' : 'none'
            }
        },
        splitter() {
            let conf = this.$props.config
            let colors = this.$props.colors
            let c = colors.grid
            let im = conf.TB_ITEM_M
            let m = (conf.TOOLBAR - conf.TB_ICON) * 0.5 - im
            let s = conf.TB_ICON + im * 2
            return {
                'width': `${s}px`,
                'height': '1px',
                'margin': `8px ${m}px 8px ${m}px`,
                'background-color': c
            }
        },
        has_multiple_items() {
            return this.data.items && this.data.items.length > 1
        }
    },
    data() {
        return {
            exp_hover: false,
            show_exp_list: false,
            sub_item: null
        }
    }
}
</script>

<style>
.tc-tbitem {
    position: relative;
}

.tc-tbitem:hover {
    background-color: rgba(249, 115, 22, 0.12);
}

/* Dark theme toolbar item hover */
.chart-page-dark .tc-tbitem:hover {
    background-color: rgba(249, 115, 22, 0.18);
}

/* ── Icon base styling ── */
.tc-tbicon {
    position: absolute;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    filter: brightness(0) saturate(100%);
}

/* Dark theme: invert icons so they appear light */
.chart-page-dark .tc-tbicon {
    filter: invert(95%) sepia(5%) saturate(376%) hue-rotate(185deg) brightness(105%) contrast(96%);
}

/* Hover / selected tool: orange tint */
.tc-tbitem:hover > .tc-tbicon,
.tcjs-item-list-item:hover > .tc-tbicon,
.tc-tbitem.selected-item > .tc-tbicon,
.tcjs-item-list-item.selected-item > .tc-tbicon {
    filter: brightness(0) saturate(100%) invert(56%) sepia(86%) saturate(1814%) hue-rotate(349deg) brightness(101%) contrast(95%) !important;
}

/* Dark theme hover / selected tool */
.chart-page-dark .tc-tbitem:hover > .tc-tbicon,
.chart-page-dark .tcjs-item-list-item:hover > .tc-tbicon,
.chart-page-dark .tc-tbitem.selected-item > .tc-tbicon,
.chart-page-dark .tcjs-item-list-item.selected-item > .tc-tbicon {
    filter: brightness(0) saturate(100%) invert(56%) sepia(86%) saturate(1814%) hue-rotate(349deg) brightness(101%) contrast(95%) !important;
}

/* ── Expand arrow ── */
.tc-tbitem-exp {
    position: absolute;
    right: -3px;
    font-stretch: extra-condensed;
    transform: scaleX(0.6);
    font-size: 0.6em;
    opacity: 0.4;
    user-select: none;
    line-height: 0;
    cursor: pointer;
    color: #111111;
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 2px;
}

.tc-tbitem:hover .tc-tbitem-exp {
    opacity: 0.7;
    color: #f97316;
    background-color: rgba(249, 115, 22, 0.12);
}

.tc-tbitem-exp:hover {
    background-color: rgba(249, 115, 22, 0.16);
    color: #f97316;
    opacity: 0.9 !important;
}

/* Dark theme expand arrow */
.chart-page-dark .tc-tbitem-exp {
    color: #eef1f6;
    background-color: rgba(255, 255, 255, 0.03);
}
.chart-page-dark .tc-tbitem:hover .tc-tbitem-exp {
    background-color: rgba(249, 115, 22, 0.18);
    color: #f97316;
    opacity: 0.7;
}
.chart-page-dark .tc-tbitem-exp:hover {
    background-color: rgba(249, 115, 22, 0.22);
    color: #f97316;
}

/* ── Pixel rendering ── */
.tcjs-pixelated {
    -ms-interpolation-mode: nearest-neighbor;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: -webkit-crisp-edges;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: pixelated;
}
</style>

<style>
.tc-tbitem .tc-tbitem-exp { border-radius:5px; background:transparent; color:#7e8591; opacity:.65; transition:background .12s,color .12s; }
.tc-tbitem:hover .tc-tbitem-exp,.tc-tbitem .tc-tbitem-exp:hover,.tc-tool-menu-open .tc-tbitem-exp { color:#303640; background:#eceef1; opacity:1!important; }
.tc-tool-menu-open .tc-tbitem-exp { border-radius:5px 0 0 5px; }
.chart-page-dark .tc-tbitem .tc-tbitem-exp { color:#a5acba; background:transparent; }
.chart-page-dark .tc-tbitem:hover .tc-tbitem-exp,.chart-page-dark .tc-tbitem .tc-tbitem-exp:hover,.chart-page-dark .tc-tool-menu-open .tc-tbitem-exp { color:#e4e7ed; background:#303642; }
</style>

<style>
.tc-tbitem .tc-tbitem-exp { opacity:0; pointer-events:none; }
.tc-tbitem:hover .tc-tbitem-exp,.tc-tbitem:focus-within .tc-tbitem-exp,.tc-tbitem.tc-tool-menu-open .tc-tbitem-exp { opacity:1; pointer-events:auto; }
@media(hover:none) { .tc-tbitem .tc-tbitem-exp { opacity:.65; pointer-events:auto; } }
</style>
<style>
.tc-tbitem .tc-tbitem-exp { z-index:2; }
</style>
